'use strict';
var symbolObservable = require('symbol-observable');

module.exports = function (fn) {
	return Boolean(fn && fn[symbolObservable]);
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/is-observable/index.js
// module id = +tau
// module chunks = 0